module.exports = __webpack_public_path__ + "static/media/volgende_onderzoek.a6a80f85.png";